//@flow
import {
    FETCH_TEAM_REQUEST,
    FETCH_TEAM_SUCCESS,
    FETCH_SINGLE_TEAM_SUCCESS,
    FETCH_TEAM_SETTINGS_REQUEST,
    FETCH_TEAM_SETTINGS_SUCCESS,
    FETCH_TEAM_SETTINGS_FAILURE,
    FETCH_TASK_PROFILE_REQUEST,
    FETCH_TASK_PROFILE_SUCCESS,
    FETCH_TASK_PROFILE_FAILURE
} from 'common/constants/actionTypes';
import * as Immutable from 'immutable';
import { TaskProfile } from 'common/models/internal/TaskProfile';
import { Team } from 'common/models/internal/Team';
import { TeamSettings } from 'common/models/internal/TeamSettings';

const initialState = {
    records: {}
};

export const team = (state = Immutable.fromJS(initialState), action) => {
    switch (action.type) {
        case FETCH_TEAM_SETTINGS_REQUEST: {
            return state.setIn(['records', 'teamSettings', 'inProgress'], true);
        }

        case FETCH_TEAM_SETTINGS_FAILURE: {
            return state.withMutations(mutableState => {
                mutableState.setIn(
                    ['records', 'teamSettings', 'inProgress'],
                    false
                );
                mutableState.setIn(
                    ['records', 'teamSettings', 'hasError'],
                    true
                );
            });
        }

        case FETCH_TEAM_SETTINGS_SUCCESS: {
            const teamSettings = TeamSettings.fromJS(action.response);
            return state.withMutations(mutableState => {
                mutableState.setIn(
                    ['records', 'teamSettings', 'entity'],
                    teamSettings
                );
                mutableState.setIn(
                    ['records', 'teamSettings', 'inProgress'],
                    false
                );
                mutableState.setIn(
                    ['records', 'teamSettings', 'hasError'],
                    false
                );
            });
        }

        case FETCH_TASK_PROFILE_REQUEST: {
            return state.withMutations(mutableState => {
                mutableState.setIn(
                    ['records', 'taskProfile', 'inProgress'],
                    true
                );
                mutableState.setIn(
                    ['records', 'taskProfile', 'hasError'],
                    false
                );
            });
        }

        case FETCH_TASK_PROFILE_FAILURE: {
            return state.withMutations(mutableState => {
                mutableState.setIn(
                    ['records', 'taskProfile', 'inProgress'],
                    false
                );
                mutableState.setIn(
                    ['records', 'taskProfile', 'hasError'],
                    true
                );
            });
        }

        case FETCH_TASK_PROFILE_SUCCESS: {
            const taskProfile = TaskProfile.fromJS(action.response);
            return state.withMutations(mutableState => {
                mutableState.setIn(
                    ['records', 'taskProfile', 'entity'],
                    taskProfile
                );
                mutableState.setIn(
                    ['records', 'taskProfile', 'inProgress'],
                    false
                );
                mutableState.setIn(
                    ['records', 'taskProfile', 'hasError'],
                    false
                );
            });
        }

        case FETCH_TEAM_REQUEST: {
            return state.setIn(['records', 'inProgress'], true);
        }

        case FETCH_TEAM_SUCCESS: {
            const teams = action.response;
            var teamIdToTeamMap = Immutable.Map();
            teams.forEach(team => {
                teamIdToTeamMap = teamIdToTeamMap.setIn(
                    [team.clientId, team.teamId],
                    Team.fromJS(team)
                );
            });
            return state.set('records', teamIdToTeamMap);
        }

        case FETCH_SINGLE_TEAM_SUCCESS: {
            const team = Team.fromJS(action.response);
            let teamsMap = Immutable.Map();
            const oldTeamsMap = state.get('records');
            if (oldTeamsMap) {
                teamsMap = oldTeamsMap;
            }
            teamsMap = teamsMap.setIn([team.clientId, team.teamId], team);
            return state.set('records', teamsMap);
        }

        default:
            return state;
    }
};
